import styled from "styled-components"

const StyledDivider = styled.hr`
  border: 0;
  border-top: 1px solid ${(props) => props.theme.colors.border};
  width: 100%;
  margin-block: clamp(2rem, 1.7rem + 1.5vw, 3.5rem);
`

const Divider = () => {
  return <StyledDivider />
}

export { Divider }
